import type { User } from "@supabase/supabase-js";
import type { UserProfile } from "../types/preferences";

/**
 * Get effective display name for a user
 * Priority: custom display name > SSO provider name > email prefix > "User"
 */
export function getEffectiveDisplayName(user: User | null, profile: UserProfile | null): string {
    // 1. User's custom display name (if they set one)
    if (profile?.display_name) return profile.display_name;

    // 2. SSO provider name (Google, etc.)
    if (user?.user_metadata?.full_name) return user.user_metadata.full_name;
    if (user?.user_metadata?.name) return user.user_metadata.name;

    // 3. Email prefix as fallback
    return user?.email?.split("@")[0] || "User";
}
